import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CdDateTimePickerOverlayDialogComponent } from './cd-date-time-picker-overlay-dialog.component';
import { DialogCloseReason, IDialogOnClose } from '../../dialogs/base-dialog';
import { DialogService } from '../../dialogs/dialog.service';
import { InputSettings } from './interface';

export const CD_DATEPICKER_CONTROL_INPUT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CdDateTimePickerInputComponent),
  multi: true
};

@Component({
  selector: 'cd-date-time-picker-input',
  template: `
    <div class="cd-date-time-picker-input-container" [style.opacity]="disabled? 0.5 : 1">
      <div class="wc-date-container" (click)="onInputClicked($event)">
        <span>{{date | MomentDate: settings.inputFormat}}</span>
        <i class="icon-cds icon-cds-calendar"></i>
      </div>
    </div>`,
  styles: [`
  `],
  providers: [CD_DATEPICKER_CONTROL_INPUT_VALUE_ACCESSOR]
})
export class CdDateTimePickerInputComponent implements OnInit, ControlValueAccessor {
  date: Date;

  dateTimeFormat: string;

  @Input() settings: InputSettings;
  @Input() disabled = false;

  controlAccessorNotifyChange: (_?: any) => void = function () {
    //insert a noop function to make things simpler when not working with forms
    return;
  };

  controlAccessorNotifyTouched: () => void = function () {
    //insert a noop function to make things simpler when not working with forms
    return;
  };

  constructor(private dialogService: DialogService, private elementRef: ElementRef) {
    this.date = new Date();
    this.date.setSeconds(0);
    this.date.setMilliseconds(0);
  }

  ngOnInit(): void {
    if (!this.settings) {
      throw new Error('for now we do not support default settings for this input it should be handed over from outside');
    }
  }

  //region ControlValueAccessor API
  writeValue(value: Date): void {
    if (value !== undefined && value !== null) {
      this.date = new Date(value);
    } else {
      this.date = new Date();
      this.date.setSeconds(0);
      this.date.setMilliseconds(0);
    }
  }

  registerOnChange(fn: any): void {
    this.controlAccessorNotifyChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.controlAccessorNotifyTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  //endregion ControlValueAccessor API

  onInputClicked(event: any) {
    if (this.disabled) {
      return; //do nothing when clicked while we are disabled .
    }

    let extraData = {
      hostElementPosition: this.elementRef.nativeElement.getBoundingClientRect(),
      calendarSettings: this.settings,
      initialValue: this.date
    };

    this.controlAccessorNotifyTouched(); //update Angular-forms infra that this "input" was touched

    this.dialogService.createDialog(CdDateTimePickerOverlayDialogComponent, extraData, {
      backdropClass: 'cd-date-time-picker-overlay-dialog-backdrop',
      closeWhenClickedOnBackdrop: true
    }).onClose.subscribe((result: IDialogOnClose) => {
      if (result.reason === DialogCloseReason.OK) {
        this.date = new Date(result.data.dateSelected);
        this.controlAccessorNotifyChange(this.date); //update Angular-forms infra that things have changed
      }
    });
  }

}

